/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FspDto,
  FspType,
  UpdateFspIncomingActiveStatusParams,
  UpdateFspOutgoingActiveStatusParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get FSP by code
 */
export const getFspByCode = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspDto>(
      {url: `/api/v1/fsps/${code}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFspByCodeInfiniteQueryKey = (code?: string,) => {
    return [
    'infinite', `/api/v1/fsps/${code}`
    ] as const;
    }

export const getGetFspByCodeQueryKey = (code?: string,) => {
    return [
    `/api/v1/fsps/${code}`
    ] as const;
    }

    
export const getGetFspByCodeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getFspByCode>>>, TError = unknown>(code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspByCodeInfiniteQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspByCode>>> = ({ signal }) => getFspByCode(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspByCodeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getFspByCode>>>
export type GetFspByCodeInfiniteQueryError = unknown


export function useGetFspByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByCode>>>, TError = unknown>(
 code: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByCode>>,
          TError,
          Awaited<ReturnType<typeof getFspByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByCode>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByCode>>,
          TError,
          Awaited<ReturnType<typeof getFspByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByCode>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSP by code
 */

export function useGetFspByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByCode>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspByCodeInfiniteQueryOptions(code,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFspByCodeQueryOptions = <TData = Awaited<ReturnType<typeof getFspByCode>>, TError = unknown>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspByCodeQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspByCode>>> = ({ signal }) => getFspByCode(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getFspByCode>>>
export type GetFspByCodeQueryError = unknown


export function useGetFspByCode<TData = Awaited<ReturnType<typeof getFspByCode>>, TError = unknown>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByCode>>,
          TError,
          Awaited<ReturnType<typeof getFspByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByCode<TData = Awaited<ReturnType<typeof getFspByCode>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByCode>>,
          TError,
          Awaited<ReturnType<typeof getFspByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByCode<TData = Awaited<ReturnType<typeof getFspByCode>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSP by code
 */

export function useGetFspByCode<TData = Awaited<ReturnType<typeof getFspByCode>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspByCodeQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update FSP
 */
export const updateFsp = (
    code: string,
    fspDto: FspDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<FspDto>(
      {url: `/api/v1/fsps/${code}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fspDto
    },
      options);
    }
  


export const getUpdateFspMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFsp>>, TError,{code: string;data: FspDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFsp>>, TError,{code: string;data: FspDto}, TContext> => {

const mutationKey = ['updateFsp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFsp>>, {code: string;data: FspDto}> = (props) => {
          const {code,data} = props ?? {};

          return  updateFsp(code,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFspMutationResult = NonNullable<Awaited<ReturnType<typeof updateFsp>>>
    export type UpdateFspMutationBody = FspDto
    export type UpdateFspMutationError = unknown

    /**
 * @summary Update FSP
 */
export const useUpdateFsp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFsp>>, TError,{code: string;data: FspDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFsp>>,
        TError,
        {code: string;data: FspDto},
        TContext
      > => {

      const mutationOptions = getUpdateFspMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete FSP
 */
export const deleteFsp = (
    code: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/fsps/${code}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteFspMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFsp>>, TError,{code: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFsp>>, TError,{code: string}, TContext> => {

const mutationKey = ['deleteFsp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFsp>>, {code: string}> = (props) => {
          const {code} = props ?? {};

          return  deleteFsp(code,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFspMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFsp>>>
    
    export type DeleteFspMutationError = unknown

    /**
 * @summary Delete FSP
 */
export const useDeleteFsp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFsp>>, TError,{code: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFsp>>,
        TError,
        {code: string},
        TContext
      > => {

      const mutationOptions = getDeleteFspMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get all FSPs
 */
export const getAllFsps = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspDto[]>(
      {url: `/api/v1/fsps`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllFspsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v1/fsps`
    ] as const;
    }

export const getGetAllFspsQueryKey = () => {
    return [
    `/api/v1/fsps`
    ] as const;
    }

    
export const getGetAllFspsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllFsps>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFspsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFsps>>> = ({ signal }) => getAllFsps(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllFspsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllFsps>>>
export type GetAllFspsInfiniteQueryError = unknown


export function useGetAllFspsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFsps>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFsps>>,
          TError,
          Awaited<ReturnType<typeof getAllFsps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFspsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFsps>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFsps>>,
          TError,
          Awaited<ReturnType<typeof getAllFsps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFspsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFsps>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all FSPs
 */

export function useGetAllFspsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFsps>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllFspsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllFspsQueryOptions = <TData = Awaited<ReturnType<typeof getAllFsps>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFspsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFsps>>> = ({ signal }) => getAllFsps(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllFspsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllFsps>>>
export type GetAllFspsQueryError = unknown


export function useGetAllFsps<TData = Awaited<ReturnType<typeof getAllFsps>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFsps>>,
          TError,
          Awaited<ReturnType<typeof getAllFsps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFsps<TData = Awaited<ReturnType<typeof getAllFsps>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFsps>>,
          TError,
          Awaited<ReturnType<typeof getAllFsps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFsps<TData = Awaited<ReturnType<typeof getAllFsps>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all FSPs
 */

export function useGetAllFsps<TData = Awaited<ReturnType<typeof getAllFsps>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFsps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllFspsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create new FSP
 */
export const createFsp = (
    fspDto: FspDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspDto>(
      {url: `/api/v1/fsps`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fspDto, signal
    },
      options);
    }
  


export const getCreateFspMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFsp>>, TError,{data: FspDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createFsp>>, TError,{data: FspDto}, TContext> => {

const mutationKey = ['createFsp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFsp>>, {data: FspDto}> = (props) => {
          const {data} = props ?? {};

          return  createFsp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFspMutationResult = NonNullable<Awaited<ReturnType<typeof createFsp>>>
    export type CreateFspMutationBody = FspDto
    export type CreateFspMutationError = unknown

    /**
 * @summary Create new FSP
 */
export const useCreateFsp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFsp>>, TError,{data: FspDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFsp>>,
        TError,
        {data: FspDto},
        TContext
      > => {

      const mutationOptions = getCreateFspMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update FSP active status
 */
export const updateFspOutgoingActiveStatus = (
    code: string,
    params: UpdateFspOutgoingActiveStatusParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<FspDto>(
      {url: `/api/v1/fsps/${code}/outgoing-active`, method: 'PATCH',
        params
    },
      options);
    }
  


export const getUpdateFspOutgoingActiveStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFspOutgoingActiveStatus>>, TError,{code: string;params: UpdateFspOutgoingActiveStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFspOutgoingActiveStatus>>, TError,{code: string;params: UpdateFspOutgoingActiveStatusParams}, TContext> => {

const mutationKey = ['updateFspOutgoingActiveStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFspOutgoingActiveStatus>>, {code: string;params: UpdateFspOutgoingActiveStatusParams}> = (props) => {
          const {code,params} = props ?? {};

          return  updateFspOutgoingActiveStatus(code,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFspOutgoingActiveStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateFspOutgoingActiveStatus>>>
    
    export type UpdateFspOutgoingActiveStatusMutationError = unknown

    /**
 * @summary Update FSP active status
 */
export const useUpdateFspOutgoingActiveStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFspOutgoingActiveStatus>>, TError,{code: string;params: UpdateFspOutgoingActiveStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFspOutgoingActiveStatus>>,
        TError,
        {code: string;params: UpdateFspOutgoingActiveStatusParams},
        TContext
      > => {

      const mutationOptions = getUpdateFspOutgoingActiveStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update FSP active status
 */
export const updateFspIncomingActiveStatus = (
    code: string,
    params: UpdateFspIncomingActiveStatusParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<FspDto>(
      {url: `/api/v1/fsps/${code}/incoming-active`, method: 'PATCH',
        params
    },
      options);
    }
  


export const getUpdateFspIncomingActiveStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFspIncomingActiveStatus>>, TError,{code: string;params: UpdateFspIncomingActiveStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFspIncomingActiveStatus>>, TError,{code: string;params: UpdateFspIncomingActiveStatusParams}, TContext> => {

const mutationKey = ['updateFspIncomingActiveStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFspIncomingActiveStatus>>, {code: string;params: UpdateFspIncomingActiveStatusParams}> = (props) => {
          const {code,params} = props ?? {};

          return  updateFspIncomingActiveStatus(code,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFspIncomingActiveStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateFspIncomingActiveStatus>>>
    
    export type UpdateFspIncomingActiveStatusMutationError = unknown

    /**
 * @summary Update FSP active status
 */
export const useUpdateFspIncomingActiveStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFspIncomingActiveStatus>>, TError,{code: string;params: UpdateFspIncomingActiveStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFspIncomingActiveStatus>>,
        TError,
        {code: string;params: UpdateFspIncomingActiveStatusParams},
        TContext
      > => {

      const mutationOptions = getUpdateFspIncomingActiveStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get FSPs by type
 */
export const getFspsByType1 = (
    type: FspType,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspDto[]>(
      {url: `/api/v1/fsps/type/${type}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFspsByType1InfiniteQueryKey = (type?: FspType,) => {
    return [
    'infinite', `/api/v1/fsps/type/${type}`
    ] as const;
    }

export const getGetFspsByType1QueryKey = (type?: FspType,) => {
    return [
    `/api/v1/fsps/type/${type}`
    ] as const;
    }

    
export const getGetFspsByType1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getFspsByType1>>>, TError = unknown>(type: FspType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspsByType1InfiniteQueryKey(type);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspsByType1>>> = ({ signal }) => getFspsByType1(type, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(type), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspsByType1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getFspsByType1>>>
export type GetFspsByType1InfiniteQueryError = unknown


export function useGetFspsByType1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspsByType1>>>, TError = unknown>(
 type: FspType, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspsByType1>>,
          TError,
          Awaited<ReturnType<typeof getFspsByType1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspsByType1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspsByType1>>>, TError = unknown>(
 type: FspType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspsByType1>>,
          TError,
          Awaited<ReturnType<typeof getFspsByType1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspsByType1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspsByType1>>>, TError = unknown>(
 type: FspType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSPs by type
 */

export function useGetFspsByType1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspsByType1>>>, TError = unknown>(
 type: FspType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspsByType1InfiniteQueryOptions(type,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFspsByType1QueryOptions = <TData = Awaited<ReturnType<typeof getFspsByType1>>, TError = unknown>(type: FspType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspsByType1QueryKey(type);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspsByType1>>> = ({ signal }) => getFspsByType1(type, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(type), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspsByType1QueryResult = NonNullable<Awaited<ReturnType<typeof getFspsByType1>>>
export type GetFspsByType1QueryError = unknown


export function useGetFspsByType1<TData = Awaited<ReturnType<typeof getFspsByType1>>, TError = unknown>(
 type: FspType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspsByType1>>,
          TError,
          Awaited<ReturnType<typeof getFspsByType1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspsByType1<TData = Awaited<ReturnType<typeof getFspsByType1>>, TError = unknown>(
 type: FspType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspsByType1>>,
          TError,
          Awaited<ReturnType<typeof getFspsByType1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspsByType1<TData = Awaited<ReturnType<typeof getFspsByType1>>, TError = unknown>(
 type: FspType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSPs by type
 */

export function useGetFspsByType1<TData = Awaited<ReturnType<typeof getFspsByType1>>, TError = unknown>(
 type: FspType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspsByType1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspsByType1QueryOptions(type,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




